import { z } from "zod";

/** Fonte primária como está em data/pesquisa/*.json (campos de origem). */
export const FontePesquisa = z
  .object({
    id: z.string(),
    titulo: z.string(),
    autor_orgao: z.string().nullish(),
    ano: z.union([z.string(), z.number()]).nullish(),
    versao: z.string().nullish(),
    url: z.string().nullish(),
    doi: z.string().nullish(),
    tipo: z.string().nullish(),
    acesso: z.string().nullish(),
  })
  .loose();
export type FontePesquisa = z.infer<typeof FontePesquisa>;

export const STATUS_FATO = ["verificado", "nao_verificado", "conflito"] as const;
export const StatusFato = z.enum(STATUS_FATO);
export type StatusFato = z.infer<typeof StatusFato>;

/** Fato conferido. Os campos específicos de cada tema (dose_min, limiar_min…) ficam soltos. */
export const FatoPesquisa = z
  .object({
    id: z.string(),
    /** Ausente em fatos derivados de cálculo sobre outros fatos. */
    fonte_id: z.string().nullable(),
    afirmacao: z.string(),
    valor: z.unknown().optional(),
    unidade: z.string().nullish(),
    localizador: z.string().nullish(),
    citacao_curta: z.string().nullish(),
    status: StatusFato,
    observacao: z.string().nullish(),
  })
  .loose();
export type FatoPesquisa = z.infer<typeof FatoPesquisa>;

export const ArquivoPesquisa = z.object({ fontes: z.array(FontePesquisa).default([]), fatos: z.array(FatoPesquisa).default([]) }).loose();

/** Entrada de data/seed/_fontes.json: como a fonte aparece no app. */
export const Sigla = z
  .object({
    sigla: z.string().min(1),
    tipo: z.string().optional(),
    nota: z.string().optional(),
    status: z.string().optional(),
    /** Fonte que é citada inteira (uma norma, por exemplo) e dispensa fato. */
    semFato: z.boolean().optional(),
  })
  .strict();
export type Sigla = z.infer<typeof Sigla>;

/** Fonte como sai na release, só com o que o app mostra. */
export const FontePublicada = z.object({
  id: z.string(),
  sigla: z.string(),
  titulo: z.string().optional(),
  orgao: z.string().optional(),
  ano: z.union([z.string(), z.number()]).optional(),
  tipo: z.string().optional(),
  url: z.string().optional(),
  doi: z.string().optional(),
  acesso: z.string(),
  nota: z.string().optional(),
  status: z.string(),
});
export type FontePublicada = z.infer<typeof FontePublicada>;
